import { Button, Divider, Modal } from "antd";
import Text from "antd/es/typography/Text";
import "./course-registration.scss";
import GeneralInformation from "../../general-information/general-information";
import { CBCheckbox } from "../../shared";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, boolean } from "yup";
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { generalInfoContent } from "../shared/utils";
import { useState } from "react";
import GSTLicenses from "../../../interfaces/gst-licenses";

interface Props {
  changeStep: (step: number) => void;
  waitList: boolean;
  data: {
    code?: string;
    name?: string;
    registrationType?: string;
    price?: string;
    license?: GSTLicenses[];
    memberDiscount?: string;
    subtotalPrice?: string;
    gst?: GSTLicenses[];
  };
}

export default function CourseRegistrationStep2(props: Props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [codeConduct, setCodeConduct] = useState<string>("");
  const [modal, contextHolderModal] = Modal.useModal();
  const { control, watch } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      object({
        content: boolean(),
      }),
    ),
    defaultValues: { content: false },
  });

  const confirm = (s: boolean) => {
    !s
      ? modal.confirm({
          title: "Confirm cancel registration",
          icon: <ExclamationCircleOutlined />,
          content:
            "Are you sure you want to cancel the registration for this course?",
          okText: "Ok",
          cancelText: "Cancel",
          onOk: () => {
            return navigate(`/SEABC/courses/${id}`);
          },
        })
      : modal.info({
          title: "Code of conduct",
          icon: <InfoCircleOutlined />,
          content: generalInfoContent("Student Code of Conduct", codeConduct),
          okText: "Ok",
          width: "70%",
        });
  };

  const switchStep = (step: number) => {
    props.changeStep(step);
  };

  const endProcess = () => {
    confirm(false);
  };

  return (
    <div className="p-10 flex flex-col justify-center items-center registration-registration-step">
      <Divider>General Information</Divider>
      <div className="py-1.5">
        <GeneralInformation
          partial={true}
          codeOfConduct={(e) => setCodeConduct(e)}
        />
      </div>
      <Divider></Divider>
      <div>
        <CBCheckbox
          label={
            <>
              I agree with the{" "}
              <Text
                onClick={() => confirm(true)}
                type="success"
                strong
                style={{ cursor: "pointer" }}
              >
                Code of conduct
              </Text>
            </>
          }
          name="content"
          control={control}
        />
      </div>
      <div className="flex justify-center gap-8 pt-10">
        <Button
          disabled={!watch("content")}
          style={{ height: "2.3rem" }}
          htmlType="submit"
          type="primary"
          icon={<CheckOutlined />}
          onClick={() => switchStep(+1)}
        >
          {!props.waitList
            ? "Continue and review my order"
            : "Confirm your seat on the waitlist."}
        </Button>
        <Button
          style={{ height: "2.3rem" }}
          icon={<RollbackOutlined />}
          htmlType="button"
          onClick={() => switchStep(-1)}
        >
          Go Back
        </Button>
        <Button
          style={{ height: "2.3rem" }}
          type="primary"
          htmlType="button"
          icon={<CloseOutlined />}
          onClick={endProcess}
          danger
        >
          Cancel
        </Button>
      </div>
      {contextHolderModal}
    </div>
  );
}

export const rowInvoice = (
  nested: boolean,
  description: React.ReactNode,
  price: React.ReactNode,
  item?: React.ReactNode,
) => {
  return (
    <div
      className="flex content-table"
      style={{ backgroundColor: !description ? "#f2f2f2" : undefined }}
    >
      <div className="flex-none w-16 py-1">{item}</div>
      <div
        className="flex-1 content-table-border py-1"
        style={{ paddingLeft: nested ? "1.5rem" : "0" }}
      >
        {description}
      </div>
      <div className="flex-none w-20 pl-2 py-1 text-right">{price}</div>
    </div>
  );
};
